import { render, staticRenderFns } from "./VDialog.vue?vue&type=template&id=280c23d6"
import script from "./VDialog.vue?vue&type=script&lang=js"
export * from "./VDialog.vue?vue&type=script&lang=js"
import style0 from "./VDialog.vue?vue&type=style&index=0&id=280c23d6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280c23d6')) {
      api.createRecord('280c23d6', component.options)
    } else {
      api.reload('280c23d6', component.options)
    }
    module.hot.accept("./VDialog.vue?vue&type=template&id=280c23d6", function () {
      api.rerender('280c23d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/VDialog.vue"
export default component.exports